import { useMeasure } from 'react-use';
import { Row, Col } from 'components/Grid';
import { PredictionMedia } from 'modules/Predictions/components/PredictionMedia';
import { MediaProvider } from 'modules/Canvas/contexts/MediaProvider';
import type { PredictionViewConfig } from 'modules/Predictions/types';
import { withGuaranteedPredStore } from 'modules/Predictions/withGuaranteedPredStore';
import { Sidebar } from './components';
import { mediaContainer, wrapper } from './styles';

interface Props {
  canvas: PredictionViewConfig['canvas'];
}
/**
 * config argument can be an object that takes specific factories/components
 * to override or provide inner functionality
 * */
export const PredictionViewCore: React.FC<Props> = withGuaranteedPredStore(({ canvas }) => {
  const [measureRef, { width, height }] = useMeasure();
  const mRefTyped = measureRef as React.LegacyRef<HTMLDivElement>;
  const canvasPadding = 120;

  return (
    <MediaProvider>
      <div className={wrapper} data-testid="modelPage-predictionView">
        <Row className={mediaContainer} spacing={0} flexWrap="nowrap">
          <Col>{canvas.mediaList}</Col>
          <Col flex={1}>
            <PredictionMedia canvas={canvas} measureRef={mRefTyped} width={width - canvasPadding} height={height - canvasPadding} />
          </Col>
          <Col>
            <Sidebar />
          </Col>
        </Row>
      </div>
    </MediaProvider>
  );
});
